import { render, staticRenderFns } from "./CtaSupport.vue?vue&type=template&id=2c1f8bd4&scoped=true"
import script from "./CtaSupport.vue?vue&type=script&lang=js"
export * from "./CtaSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1f8bd4",
  null
  
)

export default component.exports